import React, { useEffect, useState, useRef } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { MdModeEdit } from "react-icons/md";
import { IoMdCheckmark } from "react-icons/io";
import AttachmentGrid from "./Attachmentlist";
import "./meetingdetails.css"
import Hexapi from "../../utility/HexAPI/Hexapi";
import { Modal } from "react-bootstrap";
import Loader from "../../components/loader/Loader";
import { showCustomSwal } from "../../components/customswal/Customswal";
import { ViewComponent } from "../../components/attachment/ViewComponent";
import { showConfirm } from "../../utility/showconfirm";
import { MdOutlineEdit } from "react-icons/md";
const MomDrawer = ({ showMom, setShowMom, attachments, mominfo ,userid,GetMeetingDetails}) => {
  const [meetingInfoState, setMeetingInfo] = useState(mominfo?.mom || "");
  const [isEditing, setIsEditing] = useState(false);
  const [attachmentIds, setAttachmentIds] = useState([]);
  const [attachmentobj,setattachmentobj]=useState(null)
  const [viewshow,setviewshow]=useState(false)
   const[loading,setloading]=useState(false)

const [originalMom, setOriginalMom] = useState(mominfo?.mom || "");
useEffect(() => {
  if(!mominfo) return
  setMeetingInfo(mominfo?.mom || "");
  setOriginalMom(mominfo?.mom || "");
}, [mominfo]);
const handleClose = async () => {
  // check agar kuch change hua hai
  if (
    isEditing &&
    meetingInfoState !== originalMom
  ) {
    await updateMom();
  }

  setShowMom(false);
};
useEffect(() => {
  if (textareaRef.current) {
   
    const length = textareaRef.current.value.length;
    textareaRef.current.selectionStart = length;
    textareaRef.current.selectionEnd = length;

    textareaRef.current.scrollTop =
      textareaRef.current.scrollHeight;
  }
}, [meetingInfoState, isEditing]);
   const handleDeleteAttachment = async(doc) => {
const result= await showConfirm({
content: `Are you sure you want to delete ${doc.filename}?`,
  okText:"Yes",
  cancelText:"No",
  hideCancel:false
})
if(!result) return
setloading(true)
try {
    
   let queryData = {
                query: `[HRApp_Droid_Proc_DeleteAttachment_Submit] @AttachmentID='{0}', @ActivityType='{1}',@UserID='{2}'`,
                queryArr: [`${doc.attachmentid}`,`${3}`, `${userid}`]
            }
            const resp = await Hexapi(queryData)
            if(resp && resp[""] && resp[""][0]){
          const command =resp[""][0]?.command
     if (command == 1) {
        const updatedAttachments = attachmentIds.filter(
    item => item.attachmentid !== doc.attachmentid
  );

  // setAttachmentIds(updatedAttachments)
 await updateMom(updatedAttachments)
     }else{
showCustomSwal(resp[""][0]?.msg,1000)
     }}

} catch (error) {
   if(error.message =="SQL Error occurred"){
        showCustomSwal("error occurred please try again")
      }
  console.log(error)
}finally{
  setloading(false)
}
  
};
  useEffect(()=>{
    
    console.log(attachments,"console.log(attachments)")
    if(attachments.length > 0) {
      
      setAttachmentIds(attachments)
    }
  },[attachments])
  const textareaRef = useRef(null);

  useEffect(() => {
  if (showMom && isEditing) {
    setTimeout(() => {
      textareaRef.current?.focus();
    }, 10);
  }
}, [showMom, isEditing]);

  const handleFileUpload = async(file) => {
    try {
      setloading(true)
        console.log("Selected File:", file);
     let obj = {
            filename: file.name,
            extension: '.'+/[^.]+$/.exec(file.name)[0]
        }
  let queryData = {
            query: `HRApp_Droid_Proc_AddAttachment_Submit @ActivityType='{0}',@Attachment=$%$File$%$,@Extension='{1}',@Filename='{2}',@UserID='{3}'`,
            queryArr: [`${3}`, `${obj.extension}`, `${obj.filename}`, `${userid}`],
            file: file
        }

        const resp= await Hexapi(queryData)
        if(resp && resp[""] && resp[""][0]){
          const command =resp[""][0]?.command
     if (command == 1) {
  const newAttachmentIds = [
    ...attachmentIds,
    resp[""][0]
  ];

  await updateMom(newAttachmentIds);
}else{
  showCustomSwal(resp[""][0]?.msg)
}
        }
  
        console.log(resp,"resp")
    } catch (error) {
       if(error.message =="SQL Error occurred"){
            showCustomSwal("error occurred please try again")
          }
      console.log(error)
    }finally{
      setloading(false)
    }
  
  };
const updateMom=async(ids)=>{
  const getattachmentsids = ids ? ids.map((res)=>res.attachmentid) :  attachmentIds.map((res)=>res.attachmentid)
  const attIds=getattachmentsids?.join(",")
  setloading(true)
  try {
    const obj={
query:`HRApp_Droid_Proc_User_Meeting_MOM_SubmitV2 @UserID='{0}',@MeetingID='{1}',@MOM='{2}',@AttachmentIds='{3}'`,
queryArr:[`${userid}`,`${mominfo?.meetingid}`,`${meetingInfoState}` , `${attIds}`]
  }

  const resp= await Hexapi(obj)
  console.log(resp,"Respsssssssssssssss")
  setIsEditing(false);
  if(resp){
    if(resp[""][0].command == 1){

     await GetMeetingDetails(true)
      setAttachmentIds(ids);
     setTimeout(() => {
       showCustomSwal(resp[""][0].msg,1000)
     }, 500);
    }else{
      showCustomSwal(resp[""][0].msg)
    }
  }
  } catch (error) {
     if(error.message == "SQL Error occurred"){
          showCustomSwal("error occurred please try again")
        }
  }finally{
    setloading(false)
  }
  
}
const onDocClick=(doc)=>{
console.log(doc,"doc")
setattachmentobj(doc)
setviewshow(true)
}

  return (
    <div className={`momDrawer ${showMom ? "open" : ""}`} style={{zIndex:10}}>
      <div className="momDrawerHeader colorset">
        <span className="momdes">Minutes Of Meeting</span>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
          {(!isEditing && userid == mominfo?.hostempid) &&  (
            <MdOutlineEdit 
              style={{ cursor: "pointer", fontSize: "20px" }}
              onClick={() => setIsEditing(true)}
            />
            
          )}
          {(isEditing && userid == mominfo?.hostempid) && (
            <IoMdCheckmark 
              style={{ cursor: "pointer", fontSize: "20px" , color:"#29b6f6", fontWeight:600 }}
              onClick={()=>updateMom()}
            />
          )}
          <AiOutlineClose
            style={{ cursor: "pointer", fontSize: "20px" }}
            onClick={() => handleClose()}
          />
        </div>
      </div>

      <div className="momDrawerBody" style={{height:"100%"}}>
        <div className="momSection" style={{ height:"60%", padding:"10px"}}>
          <textarea
            ref={textareaRef}
            className="momInput"
            value={meetingInfoState}
            onChange={(e) => setMeetingInfo(e.target.value)}
            placeholder= {userid == mominfo?.hostempid ? "Type minutes of meeting here...": "Host hasn't attached minutes of meeting yet" }
            readOnly={!isEditing} 
            style={{
              cursor: isEditing ? "text" : "default",
            }}
          />
        </div>

        <div className="attachmentSection" style={{height:"40%"}}>
          <AttachmentGrid
            hostempid={userid == mominfo?.hostempid}
            attachments={attachmentIds}
            onFileSelect={(e) => handleFileUpload(e)}
            onDocClick={(doc) => onDocClick(doc)}
            onDelete={handleDeleteAttachment}
          />
        </div>
      </div>
{
  loading && <Modal  style={{zIndex:10 , backdropFilter:"blur(2px)"}} centered show={loading}>
<Modal.Body>
<Loader/>
</Modal.Body>
      </Modal>
}y
      {
               (attachmentobj !==null  &&  viewshow) &&  <ViewComponent userid={userid} passid={attachmentobj.attachmentid} ids={userid} filenames={attachmentobj.filename} fileExt={attachmentobj.fileext} closeModal={() => setviewshow(false)} isViewModalOpen={viewshow} />
              }
    </div>
  );
};

export default MomDrawer;